import { comparisonData } from "@/mocks/hoobuyData";

export default function ComparisonTable() {
  return (
    <section id="comparison" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            Hoobuy vs Outras Plataformas
          </h2>
          <p className="mt-3 text-base text-foreground-500 max-w-[600px] mx-auto">
            Veja por que o Hoobuy Spreadsheet é a melhor escolha para compradores brasileiros
          </p>
        </div>

        <div className="overflow-x-auto max-w-[900px] mx-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300">
                <th className="text-left py-4 px-5 text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  Funcionalidade
                </th>
                <th className="text-center py-4 px-5 text-sm font-bold text-primary-600 whitespace-nowrap bg-primary-50/50 rounded-t-lg">
                  Hoobuy Sheet
                </th>
                <th className="text-center py-4 px-5 text-sm font-semibold text-foreground-600 whitespace-nowrap">
                  Pandabuy
                </th>
                <th className="text-center py-4 px-5 text-sm font-semibold text-foreground-600 whitespace-nowrap">
                  CNFans
                </th>
                <th className="text-center py-4 px-5 text-sm font-semibold text-foreground-600 whitespace-nowrap">
                  Superbuy
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={idx} className="border-b border-background-200/70 hover:bg-background-50/50 transition-colors">
                  <td className="py-3.5 px-5 text-sm text-foreground-700 font-medium">
                    {row.feature}
                  </td>
                  <td className="text-center py-3.5 px-5 bg-primary-50/30">
                    {row.hoobuy ? (
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <i className="ri-check-line text-lg text-green-600"></i>
                      </div>
                    ) : (
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <i className="ri-close-line text-lg text-foreground-300"></i>
                      </div>
                    )}
                  </td>
                  <td className="text-center py-3.5 px-5">
                    {row.pandabuy ? (
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <i className="ri-check-line text-lg text-green-600"></i>
                      </div>
                    ) : (
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <i className="ri-close-line text-lg text-foreground-300"></i>
                      </div>
                    )}
                  </td>
                  <td className="text-center py-3.5 px-5">
                    {row.cnfans ? (
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <i className="ri-check-line text-lg text-green-600"></i>
                      </div>
                    ) : (
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <i className="ri-close-line text-lg text-foreground-300"></i>
                      </div>
                    )}
                  </td>
                  <td className="text-center py-3.5 px-5">
                    {row.superbuy ? (
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <i className="ri-check-line text-lg text-green-600"></i>
                      </div>
                    ) : (
                      <div className="w-8 h-8 flex items-center justify-center mx-auto">
                        <i className="ri-close-line text-lg text-foreground-300"></i>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}